export const DOMAIN_CSOB = "CSOB";
